import * as _ from 'underscore';
import { DataRoleFieldSynonym, DataRoleFieldSynonymWebClient } from '../../dataRole/apis/UpdateDatarole';
import { compareValues } from '../../dataRole/utils/searchUtils';
import { IDataRoleDetailInfo, IDataRoleInfo } from '../models/IDataRoleInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IDataRole, IDataRoleDetail } from '../ServerApi/types/IDataRole';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';

export module DataRoleMapper {

  const M = MapperHelper;

  export function map(
    serverApiDataRoles: IDataRole[],
    users: _.Dictionary<IUserInfo>,
    favoriteDataRoles: _.Dictionary<any> = {},
    projects: _.Dictionary<INamedItemInfo>,
  ): IDataRoleInfo[] {
    return _.map(serverApiDataRoles, (p: IDataRole) => {
      const drInfo: IDataRoleInfo = {
        id:                           p.id,
        name:                         p.name,
        owner:                        UserMapper.mapOne(users[p.ownerId]),
        updatedAt:                    M.toDate(p.updatedAt),
        contentType:                  'dataRole',
        project:                      projects[p.projectId],
        // TODO (TFSID 892845): un-const the next 3 items. Will be un-blocked whenever *favoriting dataRoles is enabled on server
        favorite:                     !!favoriteDataRoles[p.id],
        usageInfo:                    {
                                        favoritesTotal: 0,
                                        hitsTotal: 0,
                                        hitsLastOneMonthTotal: 0,
                                        hitsLastThreeMonthsTotal: 0,
                                        hitsLastTwelveMonthsTotal: 0,
                                      },
        usageInfoMaxValues:           {
                                        favoritesTotal: 0,
                                        hitsTotal: 0,
                                        hitsLastOneMonthTotal: 0,
                                        hitsLastThreeMonthsTotal: 0,
                                        hitsLastTwelveMonthsTotal: 0,
                                      },
      };
      return drInfo;
    });
  }

  export function mapDetail(p: IDataRoleDetail): IDataRoleDetailInfo {
    return {
      id:                           p.id,
      name:                         p.name,
      owner:                        UserMapper.mapOne(p.owner),
      updatedAt:                    M.toDate(p.updatedAt),
      contentType:                  'dataRole',
      favorite:                     p.favorite,
      values:                       p.values.sort(compareValues),
      dataTypes:                    p.dataType,
      description:                  p.description,
      fieldConceptUri:              p.fieldConceptUri,
      valueCount:                   p.valueCount,
      fieldSynonyms:                p.fieldConceptNames
        .map((conceptName: DataRoleFieldSynonymWebClient): DataRoleFieldSynonym => {
          const {isPrimary, ...conceptShared} = conceptName;
          return {...conceptShared, is_primary: isPrimary};
        }),
    };
  }
}
